'use strict';

var _ = require('lodash');
var moment = require('moment');
var ChartDashboardPerformanceService = function ChartDashboardPerformanceService(momentService) {
  var now = momentService.now(momentService.FIELD.DASHBOARD_DATE);
  var curMonth = now.month();
  var fullYear = now.year();
  var curYear = fullYear - 2000;
  var monthsShort = moment.monthsShort();
  var absolutePositiveBarClasses = ['positive-bar-under', 'positive-bar-over'];
  var percentagePositiveBarClasses = ['positive-bar'];
  var percentageNegativeBarClasses = ['negative-bar'];
  function getMonthIndex(month) {
    return (month + 12 - curMonth) % 12;
  }
  function monthComparator(a, b) {
    return a.position - b.position;
  }
  function sortData(data) {
    return data.sort(monthComparator);
  }
  function getLabelForSelectedMonths(data) {
    function sortRangesIfMultiple() {
      if (data.length > 1) {
        data = data.sort(function (a, b) {
          return a[0].position - b[0].position;
        });
      }
    }
    if (data) {
      sortRangesIfMultiple();
    }
    return createLabelForSelectedData(data);
  }
  function createLabelForSelectedData(data) {
    var label = '';
    _.forEach(data, function (group) {
      label = label === '' ? label + createLabelForGroup(group) : label + ', ' + createLabelForGroup(group);
    });
    return label;
  }
  function convertMonthIndexToName(monthIndex) {
    var year = curMonth <= monthIndex ? fullYear : fullYear + 1;
    return monthsShort[monthIndex] + ' ' + year;
  }
  function createLabelForGroup(group) {
    var label = convertMonthIndexToName(group[0].month);
    if (group.length > 1) {
      label = label + ' - ' + convertMonthIndexToName(group[group.length - 1].month);
    }
    return label;
  }
  function getItem(element) {
    return {
      isGap: !!element.isGap,
      month: element.month,
      position: getMonthIndex(element.month),
      metrics: element,
      data: [],
      tiles: [],
      circles: []
    };
  }
  function preparePercentageChartReferenceData(data, metric) {
    var result = [];
    for (var i = 0; i < data.length; i++) {
      var element = data[i];
      var item = getItem(element);
      if (!element.isGap) {
        var barData = metric === 'loadFactor' ? element.expected - element.finalRef : element.finalRef ? (element.expected / element.finalRef - 1) * 100 : 0;
        var dotData = metric === 'loadFactor' ? element.current - element.currentRef : element.currentRef ? (element.current / element.currentRef - 1) * 100 : 0;
        item.data = [barData];
        item.css = barData > 0 ? percentagePositiveBarClasses : percentageNegativeBarClasses;
        item.circles.push({
          value: dotData,
          css: 'dot-under'
        });
        if (element.finalRef) {
          item.metrics.expectedChangePercent = barData;
        }
        if (element.currentRef) {
          item.metrics.currentChangePercent = dotData;
        }
      }
      result.push(item);
    }
    return sortData(result);
  }
  function prepareAbsoluteChartReferenceData(data) {
    var result = [];
    var stripesData, tilesData, barsClasses;
    for (var i = 0; i < data.length; i++) {
      var element = data[i];
      var item = getItem(element);
      if (!element.isGap) {
        if (element.expected < element.current) {
          stripesData = [element.current];
          barsClasses = [absolutePositiveBarClasses[1]];
          tilesData = [{
            value: element.expected,
            className: absolutePositiveBarClasses[0]
          }];
        } else {
          stripesData = [element.expected, element.current];
          tilesData = [];
          barsClasses = absolutePositiveBarClasses;
        }
        _.extend(item, {
          data: stripesData,
          css: barsClasses,
          tiles: tilesData
        });
        if (!_.isNil(element.currentRef)) {
          item.circles.push({
            value: element.currentRef,
            css: 'dot-over'
          });
        }
        if (!_.isNil(element.finalRef)) {
          item.circles.push({
            value: element.finalRef,
            css: 'dot-under'
          });
        }
      }
      result.push(item);
    }
    return sortData(result);
  }
  function preparePercentageChartBudgetTarget(propName, data) {
    var result = [];
    for (var i = 0; i < data.length; i++) {
      var element = data[i];
      var item = getItem(element);
      if (!element.isGap) {
        var barData = element[propName] ? (element.expected / element[propName] - 1) * 100 : 0;
        item.data = [barData];
        item.css = barData > 0 ? percentagePositiveBarClasses : percentageNegativeBarClasses;
        if (!_.isNil(barData)) {
          item.metrics.expectedChangePercent = barData;
        }
      }
      result.push(item);
    }
    return sortData(result);
  }
  function preparePercentageChartBudgetData(data) {
    return preparePercentageChartBudgetTarget('budget', data);
  }
  function preparePercentageChartTargetData(data) {
    return preparePercentageChartBudgetTarget('target', data);
  }
  function prepareAbsoluteChartBudgetTargetData(propName, data) {
    var result = [];
    var stripesData, tilesData, barsClasses;
    for (var i = 0; i < data.length; i++) {
      var element = data[i];
      var item = getItem(element);
      if (!element.isGap) {
        if (element.expected < element.current) {
          stripesData = [element.current];
          barsClasses = [absolutePositiveBarClasses[1]];
          tilesData = [{
            value: element.expected,
            className: absolutePositiveBarClasses[0]
          }];
        } else {
          stripesData = [element.expected, element.current];
          tilesData = [];
          barsClasses = absolutePositiveBarClasses;
        }
        _.extend(item, {
          data: stripesData,
          css: barsClasses,
          tiles: tilesData
        });
        if (!_.isNil(element[propName])) {
          item.circles.push({
            value: element[propName],
            css: 'dot-under'
          });
        }
      }
      result.push(item);
    }
    return sortData(result);
  }
  function prepareAbsoluteChartBudgetData(data) {
    return prepareAbsoluteChartBudgetTargetData('budget', data);
  }
  function prepareAbsoluteChartTargetData(data) {
    return prepareAbsoluteChartBudgetTargetData('target', data);
  }
  function getYear() {
    return curYear;
  }
  function getMonthYear(monthData, curFullYear) {
    return monthData.position <= monthData.month ? curFullYear : curFullYear + 1;
  }
  function getDatesRanges(selectedMonthsGroups, curFullYear) {
    var momentConfig = momentService.FIELD.DASHBOARD_DATE;
    var datesRanges = [];
    var today = momentService.now(momentConfig).startOf('day');
    for (var i in selectedMonthsGroups) {
      var monthsGroup = selectedMonthsGroups[i],
        firstMonthData = monthsGroup[0],
        lastMonthData = monthsGroup[monthsGroup.length - 1],
        firstMonthYear = getMonthYear(firstMonthData, curFullYear),
        lastMonthYear = getMonthYear(lastMonthData, curFullYear);
      var startDate = momentService.of(new Date(firstMonthYear, firstMonthData.month), momentConfig);
      var endDate = momentService.of(new Date(lastMonthYear, lastMonthData.month), momentConfig).endOf('month');
      if (startDate.isBefore(today) && endDate.isAfter(today)) {
        startDate = today;
      }
      datesRanges[i] = [startDate, endDate];
    }
    return datesRanges;
  }
  return {
    preparePercentageChartReferenceData: preparePercentageChartReferenceData,
    prepareAbsoluteChartReferenceData: prepareAbsoluteChartReferenceData,
    preparePercentageChartBudgetData: preparePercentageChartBudgetData,
    preparePercentageChartTargetData: preparePercentageChartTargetData,
    prepareAbsoluteChartBudgetData: prepareAbsoluteChartBudgetData,
    prepareAbsoluteChartTargetData: prepareAbsoluteChartTargetData,
    getLabelForSelectedMonths: getLabelForSelectedMonths,
    getDatesRanges: getDatesRanges,
    getYear: getYear
  };
};
ChartDashboardPerformanceService.$inject = ['MomentService'];
module.exports = ChartDashboardPerformanceService;